var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"FAQ's","storeName":"Faqs","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/additional_info","breadcrumbs":[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/faqs'
      },
      {
        text: `FAQ's`,
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"types",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},_vm._l((item.type),function(type,index){return _c('span',{key:index},[(index != 0)?_c('span',[_c('br')]):_vm._e(),_vm._v(_vm._s(type)+" ")])}),0)],1)]}},{key:"answer",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed description-cell"},[_vm._v(" "+_vm._s(item.answer)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }